import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarCard } from "@perxis-auto/ui-kit/lib/components/CarCard";
import clsx from "clsx";
import { Constructor } from "../../../shared/ui/constructor/Constructor.js";
import styles from "./Card.module.scss.js";
const Card = memo(function Card2({ layout, widgets, className, ...props }) {
  return /* @__PURE__ */ jsx(CarCard, { className: clsx(styles.card, className), ...props, children: /* @__PURE__ */ jsx(Constructor, { isSubConstructor: true, layout, widgets }) });
});
export {
  Card
};
